<template>
  <div class="homepage">
    <div class="homepage__banner flex-cc">
<!--      <div>-->
<!--        <div class="homepage__banner-title">山东省科教人才发展继续教育平台</div>-->
<!--        <p class="homepage__banner-subtitle">Zhongke (Shandong Province) Construction Safety Training Co., L</p>-->
<!--      </div>-->
    </div>
    <div class="homepage__section homepage__section--notices">
      <div class="content">
        <div class="homepage__section--notices-top flex-sb">
          <div class="notices">
            <div class="section-caption flex-sb">
              <div class="section-caption__tag flex-fs">
                <div class="section-caption__tag-icon">
                  <img src="../assets/image/index/caption_icon.png" alt="通知公告图标" />
                </div>
                通知公告
              </div>
              <div class="section-caption__more" @click="toJump('/notices')">更多+</div>
            </div>
            <List :data="noticesList" type="2" class="notices-list" />
          </div>
          <Login
            @requestLogin="requestLogin"
            :userInfo="userInfo"
            :loginStatus="loginStatus"
          />
        </div>
<!--        <div class="homepage__section&#45;&#45;notices-bottom flex-sb">-->
<!--          <div class="news">-->
<!--            <div class="section-caption flex-sb">-->
<!--              <div class="section-caption__tag flex-fs">-->
<!--                <div class="section-caption__tag-icon">-->
<!--                  <img src="../assets/image/index/caption_icon.png" alt="建设要闻图标" />-->
<!--                </div>-->
<!--                建设要闻-->
<!--              </div>-->
<!--              <div class="section-caption__more" @click="toJump('/news')">更多+</div>-->
<!--            </div>-->
<!--            <List :data="newsList" type="1" class="news-list" />-->
<!--          </div>-->
<!--          <div class="policy">-->
<!--            <div class="section-caption flex-sb">-->
<!--              <div class="section-caption__tag flex-fs">-->
<!--                <div class="section-caption__tag-icon">-->
<!--                  <img src="../assets/image/index/caption_icon.png" alt="政策法规图标" />-->
<!--                </div>-->
<!--                政策法规-->
<!--              </div>-->
<!--              <div class="section-caption__more" @click="toJump('/policy')">更多+</div>-->
<!--            </div>-->
<!--            <List :data="policyList" type="3" class="policy-list" />-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <div class="homepage__section homepage__section--educational-process">
      <div class="section-caption">二级注册建造师继续教育流程</div>
      <div class="process-content content flex-fs">
        <div class="process-item flex-fs">
          <div class="process-item__icon">
            <img src="../assets/image/index/educational1.png" alt="注册登录" />
          </div>
          <div class="process-item__details">
            <div class="title">注册登录</div>
            <div class="description">
              完成实名注册并登录山东省建设科技与教育协会云平台。
            </div>
          </div>
        </div>
        <div class="process-item flex-fs">
          <div class="process-item__icon">
            <img src="../assets/image/index/educational2.png" alt="选购课程" />
          </div>
          <div class="process-item__details">
            <div class="title">选购课程</div>
            <div class="description">
              根据专业方向选择符合要求的必修和选修课程。
            </div>
          </div>
        </div>
        <div class="process-item flex-fs">
          <div class="process-item__icon">
            <img src="../assets/image/index/educational3.png" alt="在线学习" />
          </div>
          <div class="process-item__details">
            <div class="title">在线学习</div>
            <div class="description">
              完成规定学时并通过章节测试，部分课程需达到最低学习时长。
            </div>
          </div>
        </div>
        <div class="process-item flex-fs">
          <div class="process-item__icon">
            <img src="../assets/image/index/educational4.png" alt="发放证书" />
          </div>
          <div class="process-item__details">
            <div class="title">发放证书</div>
            <div class="description">
              学时达标后自动生成电子合格证书，作为延续注册的有效凭证。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="homepage__section homepage__section--courses content">
<!--      <div class="section-caption">二级注册建造师继续教育学习</div>-->
      <Course
        @getCourseData="fetchCourseData"
        :courseTotal="courseTotal"
        :courseList="courseList"
        :courseTypeList="courseTypeList"
        :catalogueList="catalogueList"
      />
      <div class="homepage__pagination flex-cc" v-if="courseTotal > 8">
        <el-pagination
          @current-change="changePage"
          background
          layout="prev, pager, next"
          :page-size="12"
          :page-sizes="[]"
          :total="courseTotal"
        >
        </el-pagination>
      </div>
    </div>
    <div>
      <Helper></Helper>
    </div>
  </div>
</template>
<script>
import List from "@/components/List.vue";
import Course from "@/components/Course.vue";
import Helper from "@/components/Helper.vue";
import Login from "@/components/Login.vue";
import {
  getNewsList,
  getCollectIds,
  getCourseList,
  getType,
  login,
  getUserInfo,
} from "@/api";

const CACHE_DURATION = 30 * 60 * 1000; // 30分钟缓存时间

export default {
  name: "HomePage",
  components: {Helper, List, Course, Login },
  data() {
    return {
      registerStatus: false,
      loginStatus: false,
      userInfo: {},
      newsList: [],
      policyList: [],
      noticesList: [],
      courseTypeList: [], // 课程类型
      catalogueList: [], // 专业目录
      courseList: [],
      courseTotal: 0,
      courseSearchParams: {
        courseType: "",
        catalogue: "",
        pageSize: "12",
        pageNum: 1,
      },
      isFullscreenLoading: false,
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.fetchNotices();
      this.fetchCourseData();
      this.fetchCourseTypes();
      this.checkUserLogin();
    },

    fetchNotices() {
      const noticeTypes = [2, 1, 3];
      noticeTypes.forEach(type => this.fetchNewsList(type));
    },

    fetchNewsList(noticeType, pageSize = 5) {
      const cacheKey = `newsList_${noticeType}`;
      const cachedData = this.getCachedData(cacheKey);

      if (cachedData) {
        this.updateNewsListByType(noticeType, cachedData);
        return;
      }

      this.isFullscreenLoading = true;
      getNewsList({ noticeType, pageSize })
        .then(res => {
          this.updateNewsListByType(noticeType, res.rows);
          this.cacheData(cacheKey, res.rows);
        })
        .finally(() => {
          this.isFullscreenLoading = false;
        });
    },

    updateNewsListByType(noticeType, data) {
      switch (noticeType) {
        case 1:
          this.newsList = data;
          break;
        case 2:
          this.noticesList = data;
          break;
        case 3:
          this.policyList = data;
          break;
      }
    },

    fetchCourseData(params = {
      courseType: "",
      courseMajor: "",
      pageSize: "12",
      pageNum: 1,
    }) {
      const cacheKey = 'courseData';
      this.courseSearchParams = { ...this.courseSearchParams, ...params };
      getCourseList(this.courseSearchParams)
        .then(res => {
          this.courseList = res.rows;
          this.courseTotal = res.total;
          this.cacheData(cacheKey, {
            ...this.courseSearchParams,
            rows: res.rows,
            total: res.total
          });
        });
    },

    fetchCourseTypes() {
      const courseTypeKeys = ["ej_course_type", "ej_course_major"];
      courseTypeKeys.forEach(key => {
        const cacheKey = `courseTypes_${key}`;
        const cachedData = this.getCachedData(cacheKey);

        if (cachedData) {
          this.updateCourseTypeList(key, cachedData);
          return;
        }

        getType(key)
          .then(res => {
            const storageKey = key === "ej_course_type"
              ? "courseTypeList"
              : "catalogueList";

            this[storageKey] = res.data;
            this.cacheData(cacheKey, res.data);
            localStorage.setItem(storageKey, JSON.stringify(res.data));
          });
      });
    },

    updateCourseTypeList(key, data) {
      const storageKey = key === "ej_course_type"
        ? "courseTypeList"
        : "catalogueList";

      this[storageKey] = data;
      localStorage.setItem(storageKey, JSON.stringify(data));
    },

    // 缓存数据的通用方法
    cacheData(key, data) {
      const cacheItem = {
        data: data,
        timestamp: Date.now()
      };
      localStorage.setItem(key, JSON.stringify(cacheItem));
    },

    // 获取缓存数据的通用方法
    getCachedData(key) {
      const cachedItem = localStorage.getItem(key);
      if (!cachedItem) return null;

      const parsedItem = JSON.parse(cachedItem);

      // 检查缓存是否过期
      if (Date.now() - parsedItem.timestamp > CACHE_DURATION) {
        localStorage.removeItem(key);
        return null;
      }

      return parsedItem.data;
    },

    // 其他方法保持不变
    checkUserLogin() {
      const userInfo = localStorage.getItem("userInfo");
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo);
        this.loginStatus = true;
        this.preventDuplicatePlayingPage();
      } else {
        this.loginStatus = false;
      }
    },

    preventDuplicatePlayingPage() {
      if (localStorage.getItem("repeat_unique_playing_page")) {
        const pageId = Math.random().toString(36).slice(2, 11);
        localStorage.setItem("unique_playing_page", pageId);
        localStorage.removeItem("repeat_unique_playing_page");
      }
    },

    changePage(pageNum) {
      console.log(pageNum)
      this.fetchCourseData({ ...this.courseSearchParams, pageNum });
    },

    toJump(path) {
      this.$router.push({ path });
    },

    requestLogin(loginData) {
      login(loginData)
        .then(res => {
          if (res.code === 200) {
            this.$notify({
              title: "成功",
              message: "登录成功",
              type: "success",
            });
            localStorage.setItem("token", res.token);
            this.requestUserInfo();
          }
        });
    },

    requestUserInfo() {
      Promise.all([
        getUserInfo(),
        getCollectIds(),
        getType("ej_order_state")
      ])
      .then(([userInfoRes, collectIdsRes, orderStateRes]) => {
        this.userInfo = userInfoRes.data;
        localStorage.setItem("userInfo", JSON.stringify(userInfoRes.data));
        this.loginStatus = true;

        this.collectArr = collectIdsRes.data;
        localStorage.setItem("collectArr", JSON.stringify(collectIdsRes.data));

        localStorage.setItem("orderStateList", JSON.stringify(orderStateRes.data));
      });
    },
  },
};
</script>
<style lang="less" scoped>
.homepage {
  &__banner {
    height: 910px;
    min-width: 1600px;
    background-image: url(../assets/image/index/banner.jpg);
    background-size: cover;
    color: #fff;
    text-align: center;

    &-title {
      font-size: 39px;
      margin-bottom: 15px;
    }

    &-subtitle {
      font-size: 12px;
    }
  }

  &__section {
    &--notices {
      background-color: #f3f4f8;
      padding-top: 82px;
      padding-bottom: 55px;

      .section-caption {
        margin-bottom: 28px;

        &__tag {
          background: #1265cc;
          border-radius: 5px;
          font-size: 22px;
          color: #fff;
          width: 180px;
          height: 46px;
          font-weight: bold;

          &-icon {
            padding-left: 15px;
            padding-right: 10px;

            img {
              width: 25px;
              vertical-align: sub;
            }
          }
        }

        &__more {
          font-size: 18px;
          cursor: pointer;
          color: #1265cc;
        }
      }

      &-top {
        margin-bottom: 50px;

        .notices-list {
          width: 1132px;
          height: 402px;
        }
      }

      &-bottom {
        .news-list,
        .policy-list {
          width: 782px;
          height: 334px;
        }
      }
    }

    &--educational-process {
      padding-top: 65px;

      .section-caption {
        font-size: 36px;
        text-align: center;
        margin-bottom: 15px;
      }

      .process-content {
        padding-top: 15px;

        .process-item {
          transition: transform 0.3s ease;
          width: 400px;
          height: 240px;
          padding-left: 45px;
          padding-right: 22px;
          border: 1px solid #f4f4f4;

          &__icon {
            width: 100px;
            margin-right: 28px;

            img {
              width: 100px;
            }
          }

          &__details {
            .title {
              font-size: 28px;
              color: #1265cc;
              font-weight: bold;
              margin-bottom: 20px;
            }

            .description {
              font-size: 18px;
              color: #000;
            }
          }

          &:hover {
            background: #1265cc;
            transform: translateY(-30px);

            .process-item__details {
              .title {
                color: #fff;
              }
              .description {
                color: #fff;
              }
            }
          }
        }
      }
    }

    &--courses {
      margin-top: 20px;
      margin-bottom: 100px;
    }
  }

  &__pagination {
    position: relative;
    top: -65px;
  }
}
</style>
